import Card from "./Card";
import Hero from "./Hero";
import Link from "./Link";
import Meta from "./Meta";
import TagList from "./TagList";
import Title from "./Title";
import VariantList from "./VariantList";

export default {
  Card,
  Hero,
  Link,
  Meta,
  TagList,
  Title,
  VariantList
};
